import * as _ from "lodash";
import * as React from "react";
import {AjaxResponse} from "rxjs/ajax";
import {Subject} from "rxjs";
import {DataView} from "@bizform/primereact/dataView";
import {Button} from "@bizform/primereact/components/button/Button";
import {InputText} from "@bizform/primereact/components/inputtext/InputText";
import {InputTextarea} from "@bizform/primereact/components/inputtextarea/InputTextarea";
import {Dropdown} from "@bizform/primereact/components/dropdown/Dropdown";
import {ProgressBar} from "@bizform/primereact/components/progressbar/ProgressBar";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {ExceptionType} from "@bizform/type/model/model/Exception.model";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty,
    ComponentElementPropertyEvent
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {LookUp} from "@bizform/type/model/data_type/LookUp.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {ComponentProperties} from "@bizform/type/model/component/Component.model";
import {
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {ResponseFileRead} from "@bizform/type/model/rest_api/File.model";
import {
    DoGridAction,
    GridIdKeyConstant,
    GridLinkIdKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {ConstantKey} from "@bizform/type/model/model/ConstantKey.model";
import {
    AccessibilityDropdown,
    Debug,
    DomHelper,
    FileHelper,
    FunctionHelper,
    ObjectHelper,
    StringHelper
} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    AjaxService,
    BlockHandler,
    ComponentElementClass,
    ExceptionHandler,
    FormConfigService,
    FormStateService,
    GridActionService,
    GridDataService,
    I18N,
    LookupService,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";
import {I18n} from "../../misc/model/I18n.model";


type Props =  {
};

type State =  {
    show: boolean;
    uploading: boolean;
    done: boolean;
    fileList: Array<any>;
    lookup: Array<LookUp>;
    property?: ComponentElementProperty;
    displayMode?: ComponentElementDisplayMode;
};

/**
 * Embed Form component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfFileUpload extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.COMPONENTELEMENT;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_KyVmlpyfEzLh1uLhDO22RRkNOsMWJTz",
        category: ComponentCategory.FILE,
        defaultLayoutId: DefaultLayoutId.WITHOUTLABEL,
        label: I18n.file.fileUpload.label,
        description: I18n.file.fileUpload.description,
        icon: "",
        dataType: [DataType.FILE],
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    displayMode: ComponentElementDisplayMode;
    parentDom: HTMLElement;


    /** action */
    emit(value: any) {}
    subscription(value: any, entityId?: any) {
        if ((this._prePk && this._prePk !== this.___props.grid.pk) || (this._preEntityID && this._preEntityID !== entityId)) {
            GridActionService.unRegFileUpload(this.___props, this._prePk);
        }
        if (this.___props.grid && this.___props.grid.pk) {
            if (this._prePk !== this.___props.grid.pk || this._preEntityID !== entityId) {
                GridActionService.regFileUpload(this.___props, this._onUpload);
                this._prePk = this.___props.grid.pk;
                this._preEntityID = entityId;
            }
        }
        this.setState({
            uploading: false,
            fileList: []
        });
    }
    emitDidCatch(error: Error | any): void {
        Debug.console.error(error);
    }
    onDisabled() {
        this._show(ComponentElementDisplayMode.DISABLED);
    }
    onReadOnly() {
        this._show(ComponentElementDisplayMode.READONLY);
    }
    onPrint() {
        this._show(ComponentElementDisplayMode.READONLY);
    }
    onEdit() {
        this._show(ComponentElementDisplayMode.EDIT);
    }

    focus() {
        if (this._fileButton) {
            this._fileButton.focus();
        }
    }

    readyComponent() {}

    setProperty(property: ComponentElementProperty) {
        if (!this._queryString) {
            this._queryString = JSON.stringify(FormStateService.getQueryString(this.applicationId, this.formId));
        }
        try {
            if (!property.attribute.className) {
                property.attribute.className = {value: []};
            }
            if (!property.attribute.style) {
                property.attribute.style = {value: {}};
            }
            if (!property.attribute.dClassName) {
                property.attribute.dClassName = {value: []};
            }
            if (!property.attribute.dStyle) {
                property.attribute.dStyle = {value: {}};
            }
            this._reInit = true;
            this._clearCallback();
            this._initCallback(property.event);
            this.setState({
                show: this.state.show,
                uploading: false,
                fileList: [],
                property: property
            });
        } catch (e) {
            this.emitDidCatch(e);
        }
    }

    // 코어에서 [] 보장됨
    lookupDataSubscription?(lookup: Array<LookUp>): void {
        this._reInit = true;
        this.setState({
            lookup: lookup
        });
    }

    @ReactComponentElementInit(BfFileUpload)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this._clearCallback();
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;
    ___props: ComponentProperties;

    private _button: HTMLInputElement;
    private _fileButton: HTMLInputElement;
    private _uCallback: Function;
    private _cCallback: Function;
    private _eCallback: Function;
    private _queryString: string;
    private _result: Array<any>;
    private _reInit: boolean;
    private _inUpdate: boolean;
    private _rowWidth: {
        title?: string;
        desc?: string;
        category?: string;
    };
    private _prePk: string;
    private _preEntityID: string;
    private readonly _fileDelete: any;
    private _deleteFiles: Array<number>;

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false,
            uploading: false,
            done: false,
            lookup: [],
            fileList: []
        };
        this._fileListTemplate = this._fileListTemplate.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onUpload = this._onUpload.bind(this);
        this._onGridUpload = this._onGridUpload.bind(this);
        this._onCancel = this._onCancel.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onDelete = this._onDelete.bind(this);
        this._onTitle = this._onTitle.bind(this);
        this._onCategory = this._onCategory.bind(this);
        this._onDescription = this._onDescription.bind(this);
        this._disabledUpload = this._disabledUpload.bind(this);
        this._setRef = this._setRef.bind(this);
        this._setFileRef = this._setFileRef.bind(this);
        this._autoDelete = this._autoDelete.bind(this);
        this._finishedAutoDelete = this._finishedAutoDelete.bind(this);

        this._fileDelete = _.debounce(this._autoDelete, 100);
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.emitDidCatch(error);
    }

    render(): React.ReactNode {
        const props = (this as any).___props;
        if (!this.state.show) {
            return null;
        } else if ((this.state.property.extend && !this.state.property.extend.upload) || (!props || !props.data || !props.data.dataField)) {
            return (
                <div className="bf-data-wrap p-0">
                    <div className="bf-drag p-1">
                        <div className="m-0 p-3 text-center bf-text-gray6" style={{fontSize: "1.5rem"}}>
                            {!props || !props.data || !props.data.dataField ? "Need to Link with File Entity" : "Need Upload API"}
                        </div>
                    </div>
                </div>
            );
        } else {
            if (this._reInit) {
                this._init();
            }
            const c = this.state.displayMode === ComponentElementDisplayMode.EDIT ? "position-absolute" : "d-none";
            const d = this.state.displayMode === ComponentElementDisplayMode.EDIT ? "bf-drag p-1" : "d-none";
            const a = !this.state.property.extend ? "Do not use files to drop here" : this.state.property.attribute.dropLabel.value || "Please drop files here";
            return (
                <React.Fragment>
                    <div className="bf-data-wrap p-0">
                        <div className={d}>
                            <div className="m-0 p-3 text-center bf-text-gray6" style={{fontSize: "1.5rem"}} onDrop={this._onDrop}>
                                {a}
                            </div>
                        </div>
                        <div className="mt-1 mb-1 w-100 position-relative">
                            <input ref={this._setRef} className={c} style={{top: "0px", left: "0px", width: "10px", height: "10px", opacity: 0}} name="file" type="file" multiple={this.state.property.attribute.multiple.value ? true : false} onChange={this._onChange}/>
                            <Button
                                key={this.elementId + "_click"}
                                label={this.state.property.attribute.chooseLabel.value || "Or click here to select file"}
                                className={this.state.property.attribute.className.value.join(" ")}
                                onClick={this._onClick}
                                style={{width: "100%", ...this.state.property.attribute.style.value}}
                                disabled={this.state.displayMode !== ComponentElementDisplayMode.EDIT}
                                ref={this._setFileRef}
                            />
                        </div>
                    </div>
                    {this._uploadForm()}
                </React.Fragment>
            );
        }
    }

    private _show(m: ComponentElementDisplayMode) {
        this.setState({
            show: true,
            uploading: false,
            done: false,
            fileList: [],
            displayMode: m
        });
    }

    private _init() {
        this._reInit = false;
        this.state.property.extend = this.state.property.extend ? this.state.property.extend : {};
        if (this.state.property.extend.hasDescription && this.state.lookup && this.state.lookup.length) {
            this._rowWidth = {
                title: "col-12 col-sm-6 col-md-6 com-lg-4 col-xl-4",
                category: "col-12 col-sm-6 col-md-6 com-lg-4 col-xl-4",
                desc: "col-12 col-sm-12 col-md-12 com-lg-4 col-xl-4"
            };
        } else if (this.state.property.extend.hasDescription) {
            this._rowWidth = {
                title: "col-12 col-sm-6 col-md-6 com-lg-6 col-xl-6",
                desc: "col-12 col-sm-6 col-md-6 com-lg-6 col-xl-6"
            };
        } else if (this.state.lookup && this.state.lookup.length) {
            this._rowWidth = {
                title: "col-12 col-sm-6 col-md-6 com-lg-6 col-xl-6",
                category: "col-12 col-sm-6 col-md-6 com-lg-6 col-xl-6"
            };
        } else {
            this._rowWidth = {
                title: "col-12"
            };
        }
    }

    private _uploadForm(): React.ReactNode {
        if (this.state.fileList.length) {
            const g = this.___props.grid;
            if (this._prePk && this._prePk !== g.pk) {
                GridActionService.unRegFileUpload(this.___props, this._prePk);
            }
            if (g && g.pk) {
                if (this._prePk !== g.pk) {
                    GridActionService.regFileUpload(this.___props, this._onUpload);
                    this._prePk = g.pk;
                }
            }
            this._inUpdate = GridDataService.getGridSystemData(this.formId, g[GridIdKeyConstant], g[GridLinkIdKeyConstant], g.containerElementId, g.pk) ? true : false;
            const upload = this._disabledUpload() ? null : (
                <Button
                    key={this.elementId + "_upload"}
                    label={this.state.property.attribute.uploadLabel.value || "Upload"}
                    onClick={this._inUpdate ? this._onGridUpload : this._onUpload}
                    className={this.state.property.attribute.className.value.join(" ")}
                    style={{marginRight: "0.2rem", ...this.state.property.attribute.style.value}}
                />
            );
            const button = (g && g.containerRole && !this._inUpdate) || this.state.uploading ? null : (
                <React.Fragment>
                    <div className="w-100 text-right pt-1 pb-1">
                        {upload}
                        <Button
                            key={this.elementId + "_cancel"}
                            label={this.state.property.attribute.cancelLabel.value || "Cancel"}
                            onClick={this._onCancel}
                            className={this.state.property.attribute.className.value.join(" ")}
                            style={this.state.property.attribute.style.value}
                        />
                    </div>
                </React.Fragment>
            );
            return (
                <React.Fragment>
                    <DataView
                        layout="list"
                        className={this.state.property.attribute.dClassName.value.join(" ")}
                        style={this.state.property.attribute.dStyle.value}
                        value={this.state.fileList}
                        itemTemplate={this._fileListTemplate}
                    />
                    {button}
                </React.Fragment>
            );
        } else {
            if (this._prePk) {
                GridActionService.unRegFileUpload(this.___props, this._prePk);
                this._prePk = null;
            }
            return null;
        }
    }

    private _addFiles(files: Array<any>) {
        const uploading = (this.state.done) ? false : this.state.uploading;
        if (this.state.done) {
            this.state.fileList = [];
        }
        let startIndex = this.state.fileList.length;
        for (let i = 0; i < files.length; i++) {
            const valid = this._validation(files[i], this.state.property.extend);
            files[i].index = startIndex;
            // MOVE file helper
            files[i].invalid = valid;
            files[i].delete = false;
            files[i].title = "";
            files[i].description = "";
            if (valid) {
                files[i].done = true;
            }
            startIndex++;
        }
        this.setState({
            fileList: this.state.fileList.concat(files),
            done: false,
            uploading: uploading
        });
    }

    private _validation(file: any, info: any) {
        if (!info) {
            return;
        }
        if (info.min && info.min.size || info.max && info.max.size) {
            if (info.min && info.min.size && file.size < FileHelper.getSize(info.min.size, info.min.unit)) {
                return this.state.property.attribute.minSize.value.replace(/\{0\}/g, FileHelper.transform(file.size)).replace(/\{1\}/g, info.min.size + " " + info.min.unit);
            }
            if (info.max && info.max.size && file.size > FileHelper.getSize(info.max.size, info.max.unit)) {
                return this.state.property.attribute.maxSize.value.replace(/\{0\}/g, FileHelper.transform(file.size)).replace(/\{1\}/g, info.max.size + " " + info.max.unit);
            }
        }
        if (info.extension && Array.isArray(info.extension.extension)) {
            let result = false;
            for (let i = 0; i < info.extension.extension.length; i++) {
                let extension = info.extension.extension[i].toLowerCase();
                if (!extension.startsWith(".")) {
                    extension = "." + extension;
                }
                if (file.name.toLowerCase().endsWith(extension)) {
                    result = true;
                    break;
                }
            }
            if ((result && info.extension.prevent) || (!result && !info.extension.prevent)) {
                return this.state.property.attribute.extension.value.replace(/\{0\}/g, file.name.substring(file.name.lastIndexOf(".")));
            }
        }
        return null;
    }

    private _onDrop(e: any) {
        e.preventDefault();
        if (this.state.uploading && !this.state.done) {
            return this._onUploading();
        }
        if (!this.state.property.attribute.multiple.value && ((e.dataTransfer.items || e.dataTransfer.files) as any).length > 1) {
            ExceptionHandler.toast(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.fileUpload.singleUpload}"));
            return;
        }
        if (e.dataTransfer.items) {
            let files = [];
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === "file") {
                    files.push(e.dataTransfer.items[i].getAsFile());
                }
            }
            if (files.length) {
                this._addFiles(files);
            }
        } else {
            this._addFiles(e.dataTransfer.files);
        }
    }

    private async _onChange(e: any): Promise<void> {
        this._addFiles(Array.from(e.target.files));
        await FunctionHelper.timeout(100);
        if (this._button) {
            this._button.value = "";
        }
    }

    private _onUpload() {
        if (typeof this._uCallback === "function") {
            this._uCallback();
        } else {
            this._doUpload();
        }
    }

    private _onGridUpload() {
        GridActionService.callAction(this.applicationId, this.formId, "Run" + DoGridAction.UPDATE, this._button, (this as any).___props);
    }

    private _doUpload() {
        if (!this.state.fileList.length && this.___props.grid && this.___props.grid.pk) {
            GridActionService.onEndFileUpload(this.___props);
            return;
        }
        this._result = [];
        this.setState({
            uploading: true
        });
        this._runUpload().then();
    }

    private async _runUpload(): Promise<void> {
        BlockHandler.load(this.elementId, this.parentDom);
        await FunctionHelper.timeout();
        if (!FormConfigService.updateLastAccessTimePart("ajaxCall")) {
            return;
        }
        this._deleteFiles = [];
        let size = this.state.fileList.length;
        for (let i = 0; i < this.state.fileList.length; i++) {
            if (!this.state.fileList[i].delete && !this.state.fileList[i].invalid && !this.state.fileList[i].done) {
                const formData = new FormData();
                if (this.state.fileList[i].category) {
                    formData.append("category", JSON.stringify(ObjectHelper.getLookUpFormValue(this.state.fileList[i].category, this.state.lookup)));
                }
                if (this.state.fileList[i].description) {
                    formData.append("description", this.state.fileList[i].description);
                }
                if (window[WindowKey.DESIGNMODE] || !window[WindowKey.PROCID]) {
                    formData.append("demo", "true");
                }
                formData.append("queryString", this._queryString);
                formData.append("title", this.state.fileList[i].title || this.state.fileList[i].name);
                formData.append("name", this.state.fileList[i].name);
                formData.append("projectId", this.applicationId);
                formData.append("formId", this.formId);
                formData.append("dataEntityId", (this as any).___props.data.dataField);
                formData.append("file", this.state.fileList[i]);
                if (this.___props.grid && this.___props.grid.pk) {
                    formData.append("rowPk", this.___props.grid.pk);
                    formData.append("listRowPk", this.___props.grid.pk);
                    formData.append("listDataEntityId", this.___props.data.dataField);
                    formData.append("gridEntityId", this.___props.grid[GridIdKeyConstant]);
                }
                if (this.state.property.attribute.fileUploadParameter && this.state.property.attribute.fileUploadParameter.value) {
                    const rb = LookupService.filterAPI(this.___props, "fileUploadParameter");
                    if (rb) {
                        const keys = Object.keys(rb);
                        if (Array.isArray(keys)) {
                            for (let i = 0; i < keys.length; i++) {
                                formData.append(keys[i], typeof rb[keys[i]] === "object" ? JSON.stringify(rb[keys[i]]) : rb[keys[i]]);
                            }
                        }
                    }
                }
                const progressSubscriber = new Subject();
                const request = AjaxService.reqFile(progressSubscriber, FileHelper.getFileUrl("upload", this.___props.grid && this.___props.grid.pk ? ConstantKey.DEFAULT : this.state.property.extend.upload, this.___props.grid && this.___props.grid.pk ? true : false), formData);
                let subscribe = (response: AjaxResponse | any) => {
                    let res: any = AjaxService.decrypt(response);
                    if (res.status) {
                        if (res.response && res.response.id) {
                            const result = ObjectHelper.jsonCloneDeep(res.response);
                            delete(result.RESULT);
                            delete(result.transactionId);
                            this._result.push(result);
                        } else if (Array.isArray(res.response)) {
                            this._onEndGrid(res.response);
                        }
                        this.state.fileList[i].done = true;
                        delete(this.state.fileList[i].progress);
                        size--;
                        AjaxService.fileClose(progressSubscriber, request);
                        (subscribe as any).__proto__ = null;
                        (catchSubscribe as any).__proto__ = null;
                        subscribe = null;
                        catchSubscribe = null;
                    } else {
                        this.state.fileList[i].progress = Math.floor((res.loaded / res.total) * 100);
                    }
                    this._onEnd(size);
                    res = null;
                };
                let catchSubscribe = (response: any) => {
                    let res: any = AjaxService.decrypt(response);
                    this.state.fileList[i].done = true;
                    this.state.fileList[i].invalid = AjaxService.normalizeError(res.target).faultMessage;
                    size--;
                    this._onEnd(size);
                    AjaxService.fileClose(progressSubscriber, request);
                    (subscribe as any).__proto__ = null;
                    (catchSubscribe as any).__proto__ = null;
                    subscribe = null;
                    catchSubscribe = null;
                };
                AjaxService.file(progressSubscriber, request).subscribe(subscribe, catchSubscribe);
            } else {
                size--;
            }
        }
        if (!size) {
            BlockHandler.unload(this.elementId);
        }
        if (!size && this.___props.grid && this.___props.grid.pk) {
            GridActionService.onEndFileUpload(this.___props);
            return;
        }
    }

    private _onUploading() {
        ExceptionHandler.toast(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.fileUpload.uploading}"));
    }

    private _onEndGrid(list: Array<ResponseFileRead | any>) {
        for (const key in list) {
            const index = _.findIndex(this._result, {id: list[key].id});
            if (index === -1) {
                delete(list[key].RESULT);
                delete(list[key].activitySequence);
                delete(list[key].ROW_NUMBER);
                delete(list[key].version);
                delete(list[key].caseId);
                delete(list[key].workitemSequence);
                this._result.push(list[key]);
            }
        }
    }

    private async _onEnd(size: number): Promise<void> {
        this.setState({
            done: size ? false : true,
            fileList: this.state.fileList
        });
        if (!size) {
            if (this._result.length) {
                this.emit(ObjectHelper.jsonCloneDeep(this._result));
            }
            if (typeof this._eCallback === "function") {
                this._eCallback();
            }
            FormConfigService.updateLastAccessTimePart("ajaxResponse");
            AjaxService.hook();
            if (this.___props.grid && this.___props.grid.pk) {
                if (!this._inUpdate) {
                    await FunctionHelper.timeout(200);
                }
                GridActionService.onEndFileUpload(this.___props);
            }
            BlockHandler.unload(this.elementId);
        }
    }

    private _onCancel() {
        if (typeof this._cCallback === "function") {
            this._cCallback();
        } else {
            this._doCancel();
        }
    }

    private _doCancel() {
        this.setState({
            fileList: [],
            uploading: false
        });
    }

    private _onClick() {
        if (this.state.uploading && !this.state.done) {
            return this._onUploading();
        }
        if (this._button) {
            this._button.click();
        }
    }

    private _regDelete(index: number) {
        this._deleteFiles.push(index);
    }

    private _finishedAutoDelete() {
        // BlockHandler.unload(this.elementId);
    }

    private async _autoDelete(): Promise<void> {
        if (this.state.fileList && this.state.fileList.length) {
            await FunctionHelper.timeout(1000);
            if (this.state.fileList && this.state.fileList.length) {
                for (const k in this._deleteFiles) {
                    this.state.fileList[this._deleteFiles[k]].delete = true;
                    for (let i = 0; i < this.state.fileList.length; i++) {
                        if (!this.state.fileList[i].delete) {
                            break;
                        }
                        if (i + 1 === this.state.fileList.length) {
                            this._doCancel();
                            this._finishedAutoDelete();
                            return;
                        }
                    }
                }
            }
        }
        this.setState({
            fileList: this.state.fileList
        }, this._finishedAutoDelete);
    }

    private _onDelete(e: any) {
        const index = e.target.value ? e.target.value : e.target.parentElement.value;
        this.state.fileList[index].delete = true;
        for (let i = 0; i < this.state.fileList.length; i++) {
            if (!this.state.fileList[i].delete) {
                break;
            }
            if (i + 1 === this.state.fileList.length) {
                this._doCancel();
                return;
            }
        }
        this.setState({
            fileList: this.state.fileList
        });
    }

    private _onTitle(e: any) {
        const index = e.target.getAttribute("bf-data-value");
        this.state.fileList[index].title = e.target.value;
        this.setState({
            fileList: this.state.fileList
        });
    }

    private _onCategory(e: any) {
        const index = e.target.id.substring(e.target.id.lastIndexOf("_") + 1);
        this.state.fileList[index].category = e.target.value;
        this.setState({
            fileList: this.state.fileList
        });
    }

    private _onDescription(e: any) {
        const index = e.target.getAttribute("bf-data-value");
        this.state.fileList[index].description = e.target.value;
        this.setState({
            fileList: this.state.fileList
        });
    }

    private _disabledUpload() {
        if (!this.state.property.extend || !this.state.property.extend.upload) {
            return null;
        }
        for (let i = 0; i < this.state.fileList.length; i++) {
            if (!this.state.fileList[i].delete && !this.state.fileList[i].invalid) {
                return false;
            }
        }
        return true;
    }

    private _fileListTemplate(file: any, layout: "grid" | "list") {
        if (file.delete) {
            return null;
        }
        const className = file.index + 1 < this.state.fileList.length ? "bf-line-separator p-col-12" : "p-col-12";
        const add = !this.state.property.extend || !this.state.property.extend.upload ? null : (!file.invalid ? this._fileListAddTemplate(file) : this._fileListInvalidTemplate(file));
        const progress = this.state.uploading && !file.done ? (<ProgressBar key={file.index} value={file.progress} showValue={true}/>) : null;
        if (!file.invalid && file.done) {
            this._regDelete(file.index);
            this._fileDelete();
        }
        return (
            <div key={file.index} className={className}>
                <div className="row w-100 p-0 m-0">
                    <div className="col-9">
                        {file.name}
                    </div>
                    <div className="col-2">
                        {FileHelper.transform(file.size, 2)}
                    </div>
                    <div className="col-1 text-right">
                        <Button
                            key={file.index}
                            value={file.index}
                            icon="fas fa-trash-alt"
                            className="p-button-danger"
                            tooltip={I18N.translate("{$I._app.accessibility.component.fileUpload.doDelete}")}
                            onClick={this._onDelete}
                            disabled={this.state.uploading && !file.done}
                            aria-label={I18N.translate("{$I._app.accessibility.component.fileUpload.doDelete}")}
                        />
                    </div>
                </div>
                {add}
                {progress}
            </div>
        );
    }

    private _fileListAddTemplate(file: any): React.ReactNode {
        const dest = (!this.state.property.extend.hasDescription) ? null : (
            <div className={this._rowWidth.desc + " p-1"}>
                description
                <InputTextarea
                    key={file.index}
                    value={file.description}
                    bf-data-value={file.index}
                    placeholder="Enter a description..."
                    onChange={this._onDescription}
                    disabled={this.state.uploading}
                />
            </div>
        );
        const category = (!this.state.lookup.length) ? null : (
            <div className={this._rowWidth.category + " p-1"}>
                category
                {this.accessibility ?
                    <AccessibilityDropdown
                        key={this.elementId + "_" + file.index}
                        id={this.elementId + "_" + file.index}
                        value={file.category}
                        options={this.state.lookup}
                        placeholder="Select a Category"
                        showClear={false}
                        isMultiple={false}
                        displayMode={this.displayMode}
                        onChange={this._onCategory}
                    /> : <Dropdown
                        key={this.elementId + "_" + file.index}
                        id={this.elementId + "_" + file.index}
                        value={file.category}
                        options={this.state.lookup}
                        appendTo={DomHelper.getForOverLayDom()}
                        onChange={this._onCategory}
                        placeholder="Select a Category"
                        filter={true}
                        filterBy="label,value"
                        disabled={this.state.uploading}
                    />
                }
            </div>
        );
        const done = !file.done ? null : (
            <div className="w-100 p-1 bf-bg-blue4 text-white mb-1">
                Success Upload
            </div>
        );
        return (
            <React.Fragment>
                <div className="row w-100 p-0 m-0">
                    <div className={this._rowWidth.title + " p-1"}>
                        title
                        <InputText
                            key={file.index}
                            value={file.title}
                            bf-data-value={file.index}
                            placeholder="Enter a title..."
                            onChange={this._onTitle}
                            disabled={this.state.uploading}
                        />
                    </div>
                    {category}
                    {dest}
                </div>
                {done}
            </React.Fragment>
        );
    }

    private _fileListInvalidTemplate(file: any): React.ReactNode {
        return (
            <React.Fragment>
                <div className="w-100 p-1 bf-bg-red4 text-white mb-1">
                    {file.invalid}
                </div>
            </React.Fragment>
        );
    }

    private _setRef(ref) {
        if (ref) {
            this._button = ref;
        }
    }

    private _setFileRef(ref) {
        if (ref) {
            this._fileButton = ref.element;
            this.readyComponent();
        }
    }

    private _clearCallback() {
        if (this._cCallback) {
            (this._cCallback as any).__proto__ = null;
            this._cCallback = null;
        }
        if (this._uCallback) {
            (this._uCallback as any).__proto__ = null;
            this._uCallback = null;
        }
        if (this._eCallback) {
            (this._eCallback as any).__proto__ = null;
            this._eCallback = null;
        }
        if (this._prePk) {
            GridActionService.unRegFileUpload(this.___props, this._prePk);
        }
    }

    private _initCallback(event: ComponentElementPropertyEvent) {
        const keys = Object.keys(event);
        if (keys && keys.length) {
            for (let i = 0; i < keys.length; i++) {
                let action = StringHelper.makePrintableFunctionStringArray(event[keys[i]].action)[1].trim();
                let state = event[keys[i]].formState ? event[keys[i]].formState.trim() : null;
                let cMessage = event[keys[i]].confirmMessage ? event[keys[i]].confirmMessage.trim() : null;
                if (action || state) {
                    let a = action ? FunctionHelper.stringToFunction(event[keys[i]].action) : null;
                    let s = state ? JSON.parse(state) : null;
                    this["_" + keys[i]] = () => {
                        if (cMessage) {
                            ExceptionHandler.confirm(ExceptionType.INFO, cMessage, (result) => {
                                if (result) {
                                    if (keys[i] === "uCallback") {
                                        this._doUpload();
                                    } else if (keys[i] === "cCallback") {
                                        this._doCancel();
                                    }
                                    if (state) {
                                        FormStateService.mergeState(this.applicationId, this.formId, this.elementId, s);
                                    }
                                    if (action) {
                                        a({target: this._button});
                                    }
                                }
                            });
                        } else {
                            if (keys[i] === "uCallback") {
                                this._doUpload();
                            } else if (keys[i] === "cCallback") {
                                this._doCancel();
                            }
                            if (state) {
                                FormStateService.mergeState(this.applicationId, this.formId, this.elementId, s);
                            }
                            if (action) {
                                a({target: this._button});
                            }
                        }
                    };
                }
            }
        }
    }
}
